<template>
  <b-modal
    id="disclaimerModal"
    :headerClass="`add-vello-icon`"
    centered
    hide-footer
  >
    <p class="text-justify">
      <small>
        This process will create a Stripe account for you and allow you to
        connect your bank so we can make payments to you. Payments from users
        are INSTANTLY added to your Stripe account.
      </small>
    </p>
    <p class="text-justify">
      <small>
        Each fortnight your earnings will be transferred from your Stripe
        account to your nominated bank account.
      </small>
    </p>
    <p class="text-justify">
      <small>
        All details you provide in this form are kept securely with STRIPE
        featuring best-in-class security tools and practices.
      </small>
    </p>
    <p class="text-justify">
      <small>
        Vello does not store records of information submitted via the Stripe
        form.
      </small>
    </p>
    <p>
      <b-img
        src="~@/assets/img/stripe-payment.png"
        class="d-inline-block"
        height="35px"
      />
    </p>
    <b-button
      class="radius-30 w-100 mt-4"
      variant="primary"
      @click="$emit('continue')"
    >
      Continue
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'DisclaimerModal',
}
</script>

<style scoped></style>
